import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, } from '@material-ui/core';
import clsx from 'clsx';
import { CompPanelHeader, createHeaderColumn, createPreviewItemCell, createRemoveItemCell, useModePanelStyle, useModeTableStyle, } from '../..';
const useStyle = makeStyles((theme) => {
    return {
        panelHeaderIcon: {},
        panelContent: {
            padding: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        tableContainer: {
            overflow: 'auto',
            flex: 1,
        },
        tableCol: {
            textAlign: 'left',
            '&.image-col': {
                textAlign: 'center',
                '& .image': {
                    width: 100,
                    height: 75,
                    objectFit: 'cover',
                    boxShadow: theme.shadows[2],
                },
            },
            '&.text-align-center': {
                textAlign: 'center',
            },
            '&.text-align-left': {
                textAlign: 'left',
            },
            '&.text-align-right': {
                textAlign: 'right',
            },
        },
    };
}, {
    name: 'GenericTableComp', index: 1,
});
/**
 * This is an implementation of generic table component that can be used for displaying a table of any object
 */
export const GenericTableComp = (props) => {
    const tableClasses = useModeTableStyle();
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, props.className, props.showCustomActionOnHover && 'show-custom-action-on-hover'), style: props.style, children: [_jsx(CompPanelHeader, { ...props }), _jsxs("div", { className: clsx(panelClasses.panelContent, classes.panelContent), children: [props.listData && props.listData.length > 0 && (_jsx("div", { className: classes.tableContainer, children: _jsxs(Table, { className: tableClasses.root, size: "medium", children: [_jsx(TableHead, { className: tableClasses.tableHeader, children: _jsx(TableRow, { className: tableClasses.tableHeaderRow, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                            var _a;
                                            return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                        }).map((fieldName) => {
                                            var _a, _b;
                                            const field = props.fieldsSettings.fields[fieldName];
                                            if (field && !field.hidden) {
                                                const isImage = ((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.valueType) === 'image';
                                                const textAlign = (_b = props.fieldsSettings.fields[fieldName]) === null || _b === void 0 ? void 0 : _b.textAlign;
                                                return createHeaderColumn(props.fieldsSettings, fieldName, field, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, isImage && 'image-col', textAlign && `text-align-${textAlign}`));
                                            }
                                            return _jsx(_Fragment, {});
                                        }) }) }), _jsx(TableBody, { children: props.listData.map((dataItem) => {
                                        return (_jsx(TableRow, { className: clsx(tableClasses.tableBodyRow, 'clickable', dataItem.selected && 'selected'), onClick: () => {
                                                if (props.onListItemSelected) {
                                                    props.onListItemSelected(dataItem.actualValue);
                                                }
                                            }, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                var _a;
                                                return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                            }).map((fieldName) => {
                                                var _a, _b, _c, _d, _e;
                                                if (fieldName === 'remove' && props.fieldsSettings.fields.remove
                                                    && !props.fieldsSettings.fields.remove.hidden) {
                                                    return (
                                                    // NOTE: dataItem.canBeRemoved must be true
                                                    createRemoveItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onRemoveItemClicked));
                                                }
                                                if (fieldName === 'preview' && props.fieldsSettings.fields.preview
                                                    && !props.fieldsSettings.fields.preview.hidden) {
                                                    return createPreviewItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onPreviewItemClicked);
                                                }
                                                /**
                                                 * Handle all the other fields that don't have special UI. These are the fields that
                                                 * display dataItem.displayValue as plain text
                                                 */
                                                if (props.fieldsSettings.fields[fieldName] && !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden)) {
                                                    const isImage = ((_b = props.fieldsSettings.fields[fieldName]) === null || _b === void 0 ? void 0 : _b.valueType) === 'image';
                                                    const value = (_d = (_c = dataItem.displayValue) === null || _c === void 0 ? void 0 : _c[fieldName]) !== null && _d !== void 0 ? _d : dataItem.actualValue[fieldName];
                                                    const textAlign = (_e = props.fieldsSettings.fields[fieldName]) === null || _e === void 0 ? void 0 : _e.textAlign;
                                                    return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, isImage && 'image-col', textAlign && `text-align-${textAlign}`), children: isImage ? (_jsx(_Fragment, { children: value && (_jsx("img", { className: "image", alt: value.toString(), src: value })) })) : (value === null || value === void 0 ? void 0 : value.toString()) }, fieldName));
                                                }
                                                return _jsx(_Fragment, {});
                                            }) }, JSON.stringify(dataItem.actualValue)));
                                    }) })] }) })), props.listData && props.listData.length === 0 && props.emptyDataMessageComp, props.listData && props.paginationComp, !props.listData && props.noDataMessageComp] })] }));
};
